






















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {nextTick} from "process"
import ripple from "./ripple.vue"

export interface PopupMenuItem {
    [index: number] : {
        icon: string,
        text: string,
        ["function"]: Function
    }
}

@Component({
    components : {
        ripple
    },
})
export default class PopupMenu extends Vue {
    @Prop({}) options: any;
    @Prop({}) displaced: true;
    @Prop({}) menuActive: boolean;
    @Prop({}) popupNoMax: boolean;

    popupMenuStyle = {
        transform: '',
        opacity: '0',
        left: '',
        right: '',
    };
    backgroundStyle = {
        ['transform-origin']: '',
        transform: '',
    };
    isVisible:boolean = false;
    contentType = null;

    isContentRendered:boolean=false;

    mounted() {
        this.resetCSS();
        this.determineContentType();
    }

    collection_delete(){

    }

    determineContentType(){
        if(this.options instanceof Array){
            this.contentType = 1;
        }else if(this.options instanceof Element){
            this.contentType = 2;
        }else{
        }
    }
    
    renderContent(){
        if(this.contentType != 2 || this.isContentRendered) return false;
        
        let popupMenu = this.$refs.popupMenuEl as Element;
        popupMenu.getElementsByClassName('_content')[0].innerHTML = "";
        popupMenu.getElementsByClassName('_content')[0].appendChild(this.options);
        this.isContentRendered = true;
    }

    menuCheckBleed(){
        let popupMenu = this.$refs.popupMenuEl as Element;
        let popupMenuBounds = popupMenu.getBoundingClientRect();

        if(popupMenuBounds.left < 0){
            this.popupMenuStyle.left = "2px";
        }else if(popupMenuBounds.right > window.outerWidth){
            this.popupMenuStyle.left = "auto";
            this.popupMenuStyle.right = "2px";
            this.backgroundStyle["transform-origin"] = 'top right';
        }

        this.$forceUpdate();
    }

    redirect(route,parameters?){
        if(parameters){
            this.$router.replace({ name: route, params: parameters});
        }else{
            this.$router.push({ name: route, params: parameters});
        }
    };

    closePopup(){
        this.isVisible = false;
        this.isContentRendered = false;
        nextTick(() => {
            this.resetCSS();
        });
        this.$emit('closed', true);
    }

    resetCSS(){
        this.popupMenuStyle = {
            opacity: '0',
            left: '',
            right: '',
            transform: '',
        };

        this.backgroundStyle = {
            ['transform-origin'] : '',
            transform: this.isVisible ? 'scale3d(1,1,1)' : ' '
        };
    }

    optionClicked(option) {
        this.closePopup();
        option.function();
    }

    @Watch("menuActive")
    onMenuActiveChanged(to,from) {
        if(!this.isVisible) {
            this.isVisible = true;
            nextTick(() => {
                this.menuCheckBleed();
                this.renderContent();
                this.backgroundStyle.transform = this.isVisible ? 'scale3d(1,1,1)' : ' ';
                // this.popupMenuStyle.opacity = '1';
                this.popupMenuStyle.opacity ="1";
                this.popupMenuStyle.transform  = "translate3d(0px,0px,0px)";
            })
        }
    }
    @Watch("options")
    contentChanged(to,from) {
        if(!this.isVisible){
            this.isContentRendered = false;
        }
    }
}
